// react
import React, { useState } from "react";

// react-i18next
import { useTranslation } from "react-i18next";

// @mui
import { Grid, Box, Typography, Stack, Accordion, AccordionSummary, AccordionDetails, Divider } from "@mui/material";
import { ExpandMore as ExpandMoreIcon } from "@mui/icons-material";

// A ---------------------------------------------------------------------- M

const TagToolbarPublic = ({ tag }) => {
  const { t } = useTranslation();

  const [accordionOpen, setAccordionOpen] = useState(true);

  const handleAccordionToggle = () => {
    setAccordionOpen((prev) => !prev);
  };

  const TagInformationCard = ({ tag }) => (
    <Box>
      <Stack spacing={0.5}>
        <Typography variant="body2">
          <strong>{t("id")}:</strong> {tag.id}
        </Typography>
        <Typography variant="body2">
          <strong>{t("name")}:</strong> {tag.name || "N/A"}
        </Typography>
      </Stack>
    </Box>
  );

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Accordion
          expanded={accordionOpen}
          onChange={handleAccordionToggle}
          sx={{
            boxShadow: "none",
            border: "1px solid",
            borderColor: "divider",
          }}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="h6" fontWeight="bold">
              {tag.name || "N/A"}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Divider sx={{ mb: 1 }} />
            <TagInformationCard tag={tag} />
          </AccordionDetails>
        </Accordion>
      </Grid>
    </Grid>
  );
};

export default TagToolbarPublic;
